import { TripFrm } from './trip_frm';
import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';

import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';

import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { Address } from '../../models/address';
import { Trip, SelectObj} from '../../models/trip';

@Component({
  selector: 'page-tripbrw',
  templateUrl: 'trip_brw.html',
  host: {
    '(document:keypress)': 'handleKeyboardEvent($event)'
  }
})
export class TripBrw {

  trips$: Observable<Trip[]>
  startAt$ = new Subject<string>()
  previousDate = '1900-01-01' //new Date('1900-01-01')
  dates = {}

  vehicle: SelectObj
  //  = {
  //   text: 'Ford',
  //   value: 'Ford'
  // }
  
  constructor(public navCtrl: NavController, public loadingCtrl: LoadingController, public alertCtrl: AlertController, private afs: AngularFirestore, public authData: AuthProvider) {

    this.trips$ = this.startAt$
    .switchMap(startAt => this.afs.collection<Trip>('trips', ref => ref
      .limit(30)
      .where('uid','==',this.authData.authState.uid)
      .where('vehicle.value','==',this.vehicle.value)
      .orderBy('date', 'desc')
      .orderBy('end_mileage','desc')
      .startAt(startAt)
    )
    .snapshotChanges()
    .map(trips => {
      return trips.map(trip => {
        const data = trip.payload.doc.data() as Trip
        const id = trip.payload.doc.id
        return {id, ...data}
      })
    }))
    .switchMap(trips => {
      let end_addressObservables = trips.map(trip => this.afs
        .doc<Address>('addresses/' + trip.end_address)
        .valueChanges()
        .first()
      );
      return end_addressObservables.length === 0 ?
      Observable.of(trips) :
      Observable.combineLatest(...end_addressObservables, (...addresses) => {
          trips.forEach((trip, index) => {
          trip.end_address_name = addresses[index] != null ? addresses[index].name : 'unknown';
        });
        return trips;
      });
    })

  }

  // ionViewWillEnter(){
  ngOnInit(){
    this.afs.doc<SelectObj>('settings/vehicle').valueChanges().take(1).subscribe(val => {
      this.vehicle = val
      this.presentLoading()
      this.startAt$.next('2100-01-01')
    })  
  }
  
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event);
    if (event.key == '+') this.insert();
  }

  setDate() {
    let prompt = this.alertCtrl.create({
      title: 'Back in time',
      message: "Show older trips",
      inputs: [
        {
          name: 'date',
          placeholder: 'Until date (YYYY-MM-DD)'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Show',
          handler: data => {
            this.presentLoading()
            this.startAt$.next(data.date)
          }
        }
      ]
    });
    prompt.present();    
  }

  presentLoading() {
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 200
    });
    loader.present();
  }

  test(curDate, idx) {
    this.dates[idx] = curDate
    const prevDate = this.dates[idx-1]
    console.log(curDate, idx, this.dates)
    if ((prevDate == undefined) || (curDate != prevDate)) return true
    return false
    // console.log(curDate, idx)
    // if (curDate != this.previousDate) {
    //   this.previousDate = curDate
    //   return true
    // }
    // return false
  }  

  showOnChange(currentDate, idx?) {
    if (currentDate != this.previousDate) {
      this.previousDate = currentDate
      // return currentDate
      return true
    }
    // return ''
    return false
  }

  insert(){
    this.navCtrl.push(TripFrm, {action: 1})
  }  

  change(tripSelected){
    this.navCtrl.push(TripFrm, {
      action: 2,
      key: tripSelected.id
    })
  }

  delete(tripSelected){
    this.navCtrl.push(TripFrm, {
      action: 3,
      key: tripSelected.id
    })
  }

}




// WEBPACK FOOTER //
// ./src/pages/trip/trip_brw.ts